<template>
    <zen-tooltip
        :content="disabledReason || 'Create swap'"
        placement="bottom"
        v-slot="{ setReference, ariaAttrs, show, hide }"
    >
        <!-- aria-disabled, not disabled: a native disabled button gets no hover or focus, so the reason would never show. -->
        <button
            type="button"
            :ref="(el) => setReference(el)"
            v-bind="ariaAttrs"
            aria-label="Create swap"
            :aria-disabled="isDisabled ? 'true' : undefined"
            data-testid="swap-trigger"
            class="rounded-full p-1"
            :class="
                isDisabled
                    ? 'cursor-not-allowed text-taupe-300'
                    : 'cursor-pointer text-taupe-500 hover:bg-taupe-200 hover:text-taupe-800'
            "
            @click="onClick"
            @mouseenter="show"
            @mouseleave="hide"
            @focus="show"
            @blur="hide"
        >
            <svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
                />
            </svg>
        </button>
    </zen-tooltip>
</template>

<script>
export default {
    name: 'SwapButton',
    props: {
        // Why a swap can't land here. Set, the button stays visible but grayed
        // out and shows this as its tooltip; null leaves it clickable.
        disabledReason: {
            type: String,
            default: null,
        },
    },
    emits: ['click'],
    computed: {
        isDisabled() {
            return this.disabledReason !== null
        },
    },
    methods: {
        onClick() {
            if (this.isDisabled) return

            this.$emit('click')
        },
    },
}
</script>
